import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Layout({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center gap-4">
              <img
                src="/notiq-logo.png"
                alt="Notiq"
                className="h-10"
              />
              <span className="text-xl font-bold text-gray-800">Notiq</span>
            </div>

            <nav className="hidden md:flex items-center gap-6">
              <Link
                to="/"
                className={`font-medium transition ${
                  isActive('/')
                    ? 'text-blue-600'
                    : 'text-gray-600 hover:text-blue-600'
                }`}
              >
                Dashboard
              </Link>
              <Link
                to="/contexts"
                className={`font-medium transition ${
                  isActive('/contexts')
                    ? 'text-blue-600'
                    : 'text-gray-600 hover:text-blue-600'
                }`}
              >
                Contexts
              </Link>
              <Link
                to="/captures"
                className={`font-medium transition ${
                  isActive('/captures')
                    ? 'text-blue-600'
                    : 'text-gray-600 hover:text-blue-600'
                }`}
              >
                Captures
              </Link>
              <Link
                to="/profile"
                className={`font-medium transition ${
                  isActive('/profile')
                    ? 'text-blue-600'
                    : 'text-gray-600 hover:text-blue-600'
                }`}
              >
                Profile
              </Link>
            </nav>

            <div className="flex items-center gap-4">
              {user?.picture && (
                <img
                  src={user.picture}
                  alt={user.name}
                  className="w-8 h-8 rounded-full"
                />
              )}
              <span className="text-sm text-gray-600 hidden sm:block">{user?.name}</span>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 mt-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-2">
              <span className="text-sm text-gray-600">Powered by</span>
              <img
                src="/techtonic-logo.png"
                alt="Techtonic Systems"
                className="h-6"
              />
            </div>
            <p className="text-sm text-gray-500">
              © 2025 Techtonic Systems. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
